import { Meta, StoryObj } from '@storybook/react';

import { Card } from './Card';

const meta: Meta<typeof Card> = {
  title: 'parts/link button/Card',
  component: Card,
  args: {
    addClass: [],
    children: <>card</>,
    to: '#',
  },
};

export default meta;

type Story = StoryObj<typeof Card>;

export const Basic: Story = {
  render: args => (
    <div style={{ padding: 20 }}>
      <Card {...args}>{args.children}</Card>
    </div>
  ),
};
